export const DASHBOARD = '/'
export const LOGIN = '/login'
export const SIGN_UP = '/signup'
export const PROFILE = '/p/:username'
export const NOT_FOUND = '/not-found'
export const ADD_POST = '/add-post'
